<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
        <div style="background: #FFFBF6;height: auto">
          <div class="justify-content-center column pt-5 mt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.cima_agree[4]') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
            <div class="row justify-content-center">
                <div class="justify-content-center row mt-5">
                    <div class="mb-5" style="flex: 1 1 0%; text-align: left; margin-left: 10%;">
                      <p class="text-lg mb-2" style="font-size: 18px !important;">
                          <strong>{{ $t('home_page.cima_agree[5]') }}</strong> {{ $t('home_page.cima_agree[6]') }} <strong>{{ $t('home_page.cima_agree[7]') }}</strong>, {{ $t('home_page.cima_agree[8]') }}
                      </p>
                      <p class="mt-4 text-lg" style="font-size: 18px !important;">
                      {{ $t('home_page.cima_agree[9]') }} <strong style="color: rgb(255, 164, 9);">{{ $t('home_page.cima_agree[10]') }}</strong>{{ $t('home_page.cima_agree[11]') }}
                      </p>
                    </div>
                    <div style="width: 50px;"></div>
                    <div style="flex: 1 1 0%; text-align: right; margin-right: 10%;">
                      <img src="../../assets/img/home/new_home/start_cima.png" alt="numéro un" style="margin-top: -10px;">
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <div>
        <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
        <div style="background: #FFFBF6;height:auto">
          <div class="justify-content-center column pt-5 pb-4">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop"
                  style="font-size: 20px;padding-left: 20px!important;padding-right: 20px!important;">
                {{ $t('home_page.cima_agree[4]') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="justify-content-center column pt-5">
                <div class="justify-content-center row pt-3">
                  <p class="ml-5 mr-5" style="font-size: 18px !important;">
                    <strong>{{ $t('home_page.cima_agree[5]') }}</strong>{{ $t('home_page.cima_agree[6]') }} <strong>{{ $t('home_page.cima_agree[7]') }}</strong>, {{ $t('home_page.cima_agree[8]') }}
                  </p>
                </div>
                <div class="justify-content-center row mt-5">
                  <img src="../../assets/img/home/new_home/start_cima.png" alt="numéro un" style="margin-top: -30px; width: 70%;">
                </div>
                <div class="justify-content-center row pt-5">
                  <p class="ml-5 mr-5" style="font-size: 18px !important;">
               {{ $t('home_page.cima_agree[9]') }} <strong style="color: rgb(255, 164, 9);">{{ $t('home_page.cima_agree[10]') }}</strong>{{ $t('home_page.cima_agree[11]') }}
                  </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';

export default {
  name: 'partenaire_section',
  components: {
    simplebar
  },
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}


a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

.text-lg-left {
  text-align: left !important;
}

.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}

</style>

